import script from "./PersonalisationFinishPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalisationFinishPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalisationFinishPage.vue?vue&type=style&index=0&id=ed87b774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed87b774"]])

export default __exports__